import {
	SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE,
	GETTING_STARTED_PAGE_LEARN_BY_DOING,
	YOUR_WORK,
} from '../constants';

export const shouldShowLearnByDoingBanner = (
	isProjectAdmin: boolean,
	referrer: string = '',
): boolean =>
	isProjectAdmin &&
	(referrer === GETTING_STARTED_PAGE_LEARN_BY_DOING ||
		referrer === YOUR_WORK ||
		referrer === SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE);
